import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { PublicUser } from '@pixacare/domain';
import { mergeMap } from 'rxjs';
import { usersActions } from '../users/users.actions';
import { examinationsActions } from './examinations.actions';
import { ExaminationResponsesByExaminationFormId } from './models/examination-response-by-examination-form-id';

@Injectable()
export class ExaminationsEffects {
  private readonly actions$ = inject(Actions);

  addExamination$ = createEffect(() =>
    this.actions$.pipe(
      ofType(examinationsActions.updateExaminationsState),
      mergeMap(({ examinations }) => [
        usersActions.updateUsers({
          users: this.getExaminationResponsesUsers(examinations),
        }),
      ]),
    ),
  );

  private getExaminationResponsesUsers(examinations: ExaminationResponsesByExaminationFormId): PublicUser[] {
    const users = new Map<number, PublicUser>();
    Object.values(examinations)
      .flat()
      .forEach((examination) => {
        if (examination.createdBy) {
          users.set(examination.createdBy, examination.createdByInstance);
        }
        if (examination.updatedBy) {
          users.set(examination.updatedBy, examination.updatedByInstance);
        }
      });
    return Array.from(users.values());
  }
}
